<template>
  <button type="button"
          class="play-button"
          v-on:click="toggleAudio"
  >
    <span>
      <span>
        <span>
          <span v-if="playing">■</span>
          <span v-if="!playing">▶︎</span>
        </span>
      </span>
    </span>
  </button>
</template>

<script>
import AudioElement from '@/mixins/AudioElement';

export default {
  name: 'PlayButtonHeader.vue',
  mixins: [new AudioElement()],
};
</script>

<style scoped>
  .play-button {
    display: inline-block;
    background: none;
    border: none;
    padding: 0;
    height: 102px;
    width: 102px;
    cursor: pointer;
  }

  .play-button span {
    border-radius: 100px;
    border-color: rgba(216, 161, 88, 1);
    border-width: 1px;
    border-style: solid;
    display: inline-block;
    transition: .2s all linear;

    margin: 50%;
    transform: translate(-50%, -50%);
  }

  .play-button > span {
    border-width: 1px;
    border-color: rgba(216, 161, 88, .15);
    width: 100px;
    height: 100px;

    margin: 0;
    transform: none;
  }

  .play-button > span > span {
    border-width: 1px;
    border-color: rgba(216, 161, 88, .35);
    transition-delay: .2s;
    width: 80px;
    height: 80px;
  }

  .play-button > span > span > span {
    border-width: 2px;
    border-color: rgba(216, 161, 88, .95);
    width: 50px;
    height: 50px;
    transition-delay: .4s;

  }

  .play-button > span > span > span > span {
    margin: 50%;
    transform: translate(-50%, -50%);
    font-size: 25px;
    color: #ffffff;
    border: none;
    transition-delay: .6s;
    font-stretch: expanded;
  }

  .play-button:hover > span > span > span > span {
    color: #d8a158;
    cursor: pointer;
    transition-delay: 0s;
  }

  .play-button:hover > span {
    transition-delay: .6s;
    border-color: rgba(255, 255, 255, .15);
  }

  .play-button:hover > span > span {
    transition-delay: .4s;
    border-color: rgba(255, 255, 255, .35);
  }

  .play-button:hover > span > span > span {
    transition-delay: .2s;
    border-color: rgba(255, 255, 255, .95);
  }

  span.paused {
    content: "▶";
  }
  span.playing {
    content: "■";
  }
</style>
